import { FavouriteConversationsPage } from "@features/conversations/components/FavouriteConversationsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/_teacher-portal/conversations")({
	component: FavouriteConversationsPage,
	staticData: { crumb: { label: "Conversations" } },
});
